// extracted by mini-css-extract-plugin
export default {"account":"AccountSuggestion_account__vLycp","accountName":"AccountSuggestion_accountName__bXURh","header":"AccountSuggestion_header__IfxI5"};